// src/enhancer.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { default as axios3 } from "axios";
// src/slots/CacheSlot.ts
import clone2 from "clone";
// src/libs/cloneResponse.ts
import clone from "clone";
var cloneResponse = function(response, config) {
    var next = Object.assign({}, response);
    next.data = clone(next.data, false);
    next.headers = clone(next.headers, false);
    next.config = config;
    return next;
};
// src/libs/mergeSlotOptions.ts
var mergeSlotOptions = function(globalOptions, localOptions) {
    if (!globalOptions && !localOptions) {
        return {
            enable: true
        };
    }
    var globalOpts = typeof globalOptions === "boolean" ? {
        enable: globalOptions
    } : globalOptions;
    var localOpts = typeof localOptions === "boolean" ? {
        enable: localOptions
    } : localOptions;
    var next = Object.assign({}, globalOpts, localOpts);
    if (localOpts && localOpts.enable !== false) {
        next.enable = true;
    }
    return next;
};
// src/libs/isForceEnable.ts
var isForceEnable = function(config) {
    return config && (config === true || typeof config === "object" && config.enable !== false);
};
// src/slots/CacheSlot.ts
var _CacheSlot = /*#__PURE__*/ function() {
    "use strict";
    function _CacheSlot1(options) {
        this.options = options;
        this.cacheMap = {};
    }
    var _proto = _CacheSlot1.prototype;
    _proto.hit = function hit(config, newCache) {
        var _this = this;
        var options = mergeSlotOptions(this.options, config.cache);
        var _options_allowedMethods = options.allowedMethods, allowedMethods = _options_allowedMethods === void 0 ? _CacheSlot.defaultAllowedMethods : _options_allowedMethods, validate = options.validate;
        var enable = options.enable !== false && (isForceEnable(config.cache) || allowedMethods.includes(config.method.toLowerCase())) && (!validate || validate(config));
        if (!enable) {
            return newCache(config);
        }
        var _options_maxAge = options.maxAge, maxAge = _options_maxAge === void 0 ? _CacheSlot.defaultMaxAge : _options_maxAge, format = options.format;
        var formatConfig = _CacheSlot.getFormatConfig(config);
        var key = JSON.stringify(format ? format(clone2(formatConfig, false)) : formatConfig);
        var cacheData = this.cacheMap[key];
        if (cacheData) {
            if (cacheData.time + maxAge >= Date.now()) {
                return Promise.resolve(cloneResponse(cacheData.response, config));
            }
            delete this.cacheMap[key];
        }
        return newCache(config).then(function(response) {
            _this.cacheMap[key] = {
                time: Date.now(),
                response: cloneResponse(response, response.config)
            };
            return response;
        });
    };
    _proto.clear = function clear(filter) {
        if (!filter) {
            this.cacheMap = {};
            return;
        }
        var keys = Object.keys(this.cacheMap);
        for(var i = keys.length, key; i-- > 0;){
            key = keys[i];
            if (filter(JSON.parse(key))) {
                delete this.cacheMap[key];
            }
        }
    };
    _CacheSlot1.getFormatConfig = function getFormatConfig(config) {
        return this.formatKeys.reduce(function(carry, key) {
            carry[key] = config[key];
            return carry;
        }, {});
    };
    return _CacheSlot1;
}();
var CacheSlot = _CacheSlot;
CacheSlot.defaultMaxAge = 10 * 60 * 1e3;
CacheSlot.formatKeys = [
    "baseURL",
    "url",
    "method",
    "params",
    "data",
    "headers"
];
CacheSlot.defaultAllowedMethods = [
    "get"
];
// src/libs/preventTransform.ts
var preventTransform = function(promise, transform) {
    return {
        then: function() {
            transform.push.apply(transform, arguments);
            return promise;
        }
    };
};
// src/libs/overrideRequest.ts
import { Axios } from "axios";
var overrideRequest = function(instance) {
    Object.keys(Axios.prototype).forEach(function(key) {
        instance[key] = Axios.prototype[key].bind(instance);
    });
    var originalRequest = instance.request;
    instance.request = function focaRequest(config) {
        var shouldUnwrap = true;
        var promise = originalRequest(config).then(function(response) {
            return shouldUnwrap ? response.data : response;
        });
        promise.toRaw = function toRawResponse() {
            shouldUnwrap = false;
            return promise;
        };
        return promise;
    };
};
// src/slots/RetrySlot.ts
import axios from "axios";
var _RetrySlot = /*#__PURE__*/ function() {
    "use strict";
    function _RetrySlot1(options) {
        this.options = options;
    }
    var _proto = _RetrySlot1.prototype;
    _proto.validate = function validate(err, config, currentTimes) {
        var options = mergeSlotOptions(this.options, config.retry);
        var _options_delay = options.delay, delay = _options_delay === void 0 ? _RetrySlot.defaultDelay : _options_delay, _options_maxTimes = options.maxTimes, maxTimes = _options_maxTimes === void 0 ? _RetrySlot.defaultMaxTimes : _options_maxTimes, _options_allowedMethods = options.allowedMethods, allowedMethods = _options_allowedMethods === void 0 ? _RetrySlot.defaultAllowedMethods : _options_allowedMethods, _options_allowedHttpStatus = options.allowedHttpStatus, allowedHttpStatus = _options_allowedHttpStatus === void 0 ? _RetrySlot.defaultAllowedHttpStatus : _options_allowedHttpStatus, validate = options.validate;
        var enable = options.enable !== false && currentTimes <= maxTimes && !axios.isCancel(err) && (isForceEnable(config.retry) || allowedMethods.includes(config.method.toLowerCase())) && (!err.response || this.isAllowedStatus(err.response, allowedHttpStatus)) && (!validate || validate(config));
        return new Promise(function(resolve) {
            if (enable) {
                setTimeout(function() {
                    resolve(true);
                }, delay);
            } else {
                resolve(false);
            }
        });
    };
    _proto.isAllowedStatus = function isAllowedStatus(response, allowedHttpStatus) {
        var currentStatus = response.status;
        return allowedHttpStatus.some(function(range) {
            return typeof range === "number" ? range === currentStatus : currentStatus >= range[0] && currentStatus <= range[1];
        });
    };
    return _RetrySlot1;
}();
var RetrySlot = _RetrySlot;
RetrySlot.defaultAllowedMethods = [
    "get",
    "head",
    "put",
    "patch",
    "delete"
];
RetrySlot.defaultAllowedHttpStatus = [
    [
        100,
        199
    ],
    429,
    [
        500,
        599
    ]
];
RetrySlot.defaultMaxTimes = 3;
RetrySlot.defaultDelay = 100;
// src/slots/ThrottleSlot.ts
import axios2, { AxiosError as AxiosError2 } from "axios";
import clone3 from "clone";
var _ThrottleSlot = /*#__PURE__*/ function() {
    "use strict";
    function _ThrottleSlot1(options) {
        this.options = options;
        this.threads = {};
    }
    var _proto = _ThrottleSlot1.prototype;
    _proto.hit = function hit(config, newThread) {
        var _this = this;
        var options = mergeSlotOptions(this.options, config.throttle);
        var _options_allowedMethods = options.allowedMethods, allowedMethods = _options_allowedMethods === void 0 ? _ThrottleSlot.defaultAllowedMethods : _options_allowedMethods, format = options.format, validate = options.validate;
        var enable = options.enable !== false && (isForceEnable(config.throttle) || allowedMethods.includes(config.method.toLowerCase())) && (!validate || validate(config));
        if (!enable) {
            return newThread(config);
        }
        var formatConfig = _ThrottleSlot.getFormatConfig(config);
        var key = JSON.stringify(format ? format(clone3(formatConfig, false)) : formatConfig);
        var thread = this.threads[key];
        if (thread) {
            return thread.then(function(response) {
                return cloneResponse(response, config);
            }).catch(function(err) {
                return Promise.reject(axios2.isCancel(err) ? err : new AxiosError2(err.message, err.code, config, err.request, err.response ? cloneResponse(err.response, config) : void 0));
            });
        }
        var promise = this.threads[key] = newThread(config);
        var clearThread = function() {
            delete _this.threads[key];
        };
        promise.then(clearThread, clearThread);
        return promise;
    };
    _ThrottleSlot1.getFormatConfig = function getFormatConfig(config) {
        return this.formatKeys.reduce(function(carry, key) {
            carry[key] = config[key];
            return carry;
        }, {});
    };
    return _ThrottleSlot1;
}();
var ThrottleSlot = _ThrottleSlot;
ThrottleSlot.formatKeys = [
    "baseURL",
    "url",
    "method",
    "params",
    "data",
    "headers",
    "timeout",
    "maxContentLength",
    "maxBodyLength",
    "xsrfCookieName",
    "xsrfHeaderName"
];
ThrottleSlot.defaultAllowedMethods = [
    "get",
    "head",
    "put",
    "patch",
    "delete"
];
// src/slots/RequestSlot.ts
import { AxiosError as AxiosError3 } from "axios";
var RequestSlot = /*#__PURE__*/ function() {
    "use strict";
    function RequestSlot(defaultAdapter, getHttpStatus) {
        this.defaultAdapter = defaultAdapter;
        this.getHttpStatus = getHttpStatus;
        if (!defaultAdapter) {
            throw new Error("axios default adapter is not found.");
        }
    }
    var _proto = RequestSlot.prototype;
    _proto.hit = function hit(config, param, shouldLoop) {
        var _param = _slicedToArray(param, 2), onResolve = _param[0], onReject = _param[1];
        var _this = this;
        var adapter = this.defaultAdapter;
        var loop = function(currentTimes) {
            return adapter(config).then(onResolve, onReject).then(function(response) {
                var getHttpStatus = config.getHttpStatus || _this.getHttpStatus;
                if (config.validateStatus && getHttpStatus) {
                    var realHttpStatus = getHttpStatus(response);
                    if (!config.validateStatus(realHttpStatus)) {
                        return Promise.reject(new AxiosError3("Request failed with status code " + realHttpStatus, void 0, response.config, response.request, response));
                    }
                }
                return response;
            }).catch(function(err) {
                return shouldLoop(err, config, currentTimes + 1).then(function(enable) {
                    return enable ? loop(currentTimes + 1) : Promise.reject(err);
                }, function() {
                    return Promise.reject(err);
                });
            });
        };
        return loop(0);
    };
    return RequestSlot;
}();
// src/enhancer.ts
var originalCreate = axios3.create;
axios3.create = function(config) {
    if (config === void 0) config = {};
    var instance = originalCreate(config);
    return config.enhance ? config.enhance(instance) || instance : enhance(instance, config);
};
var enhance = function(instance, options) {
    if (options === void 0) options = {};
    overrideRequest(instance);
    var cache = new CacheSlot(options.cache);
    var throttle = new ThrottleSlot(options.throttle);
    var request = new RequestSlot(instance.defaults.adapter, options.getHttpStatus);
    var retry = new RetrySlot(options.retry);
    var validateRetry = retry.validate.bind(retry);
    instance.defaults.adapter = function focaAdapter(config) {
        var transformHandler = [];
        var promise = Promise.resolve().then(function() {
            return cache.hit(config, function() {
                return throttle.hit(config, function() {
                    return request.hit(config, transformHandler, validateRetry);
                });
            });
        });
        return preventTransform(promise, transformHandler);
    };
    instance.clearCache = cache.clear.bind(cache);
    return instance;
};
// src/index.ts
export * from "axios";
import { default as default2 } from "axios";
export { CacheSlot, RetrySlot, ThrottleSlot, default2 as axios, cloneResponse, enhance, mergeSlotOptions, overrideRequest, preventTransform };
//# sourceMappingURL=index.js.map